import React from 'react';
import './Styles/InfoModal.scss'; // Import your CSS styles for the modal

const InfoModal = ({ closeModal }) => {
    return (
        <div className="modal">
            <div className="modal-content info-modal">
                <h2>Product Code Format</h2>
                <p>To add a product code, use the following format:</p>
                <p><strong>Brand name, Size , Color, Price, Name, 10 Digit Code .</strong></p>
                <p>Example: <strong>Nike-00M-Black-Jacket-2000-qwertscfed</strong></p>
                <ul>
                    <li>Brand: Nike</li>

                    <li>Size: M</li>
                    <li>Product Name: Jacket</li>
                    <li>Price: 2000</li>
                   
                    <li>Product Name: Short</li>
                    <li>Code: qwertscfed</li>
                </ul>
                <span className="close" onClick={closeModal}>&times;</span>
            </div>
        </div>
    );
};

export default InfoModal;
